
import { useEffect, useState } from 'react';

const StoryHero = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <section 
      className="h-[66.67vh] flex items-center justify-center relative overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/2e1ac11483faca2c19cd44d7d582b015/b1f556339958d4bd284ac354f2fbba45.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'left center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="relative z-10 w-full max-w-6xl mx-auto px-8 text-center">
        <div className="text-center">
          <h1 
            className="text-3xl lg:text-5xl font-light text-white mb-8 leading-tight"
            style={{ fontFamily: 'Noto Serif SC, serif' }}
          >
            品牌故事
          </h1>
          <p 
            className="text-sm lg:text-base text-white/90 max-w-4xl mx-auto leading-relaxed lg:whitespace-nowrap"
            style={{ fontFamily: 'PingFang SC, -apple-system, BlinkMacSystemFont, sans-serif', fontWeight: 100 }}
          >
            从紫禁城深宫到现代都市，宫廷养森承载着东方养生文化的精髓，为现代人开启内调外养的美丽之旅
          </p>
        </div>
      </div>

      <div className="absolute top-1/4 left-1/4 w-2 h-2 rounded-full animate-pulse" style={{ backgroundColor: '#ED5736' }}></div>
      <div className="absolute top-1/3 right-1/3 w-1 h-1 rounded-full animate-pulse delay-1000" style={{ backgroundColor: 'rgba(237, 87, 54, 0.6)' }}></div>
      <div className="absolute bottom-1/4 right-1/4 w-3 h-3 rounded-full animate-pulse delay-500" style={{ backgroundColor: 'rgba(237, 87, 54, 0.4)' }}></div>
    </section>
  );
};

export default StoryHero;
